export default "__VITE_ASSET__7QvAJdGX__"